import React from 'react'

const NotFound = () => {
  return (
    <div className='text-white'>Page Not Found</div>
  )
}

export default NotFound